import { SET_ARCHIVE_DATA, SET_ARCHIVE_LOADING, SET_SIDEBAR_ITEM, SET_SIDEBAR_LOADING } from "store/actions/archiveAction";

const initialState = {
  archiveSideBarItem: [],
  archiveItem: [],
  archiveLoading: false,
  archiveDataLoading: false,
};

const archiveSidebarReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_SIDEBAR_ITEM:
      return {
        ...state,
        archiveSideBarItem: action.payload,
        archiveLoading: true,
      };
    case SET_ARCHIVE_DATA:
      return {
        ...state,
        archiveItem: action.payload,
        archiveDataLoading: true,
      };
    case SET_SIDEBAR_LOADING:
      return {
        ...state,
        archiveLoading: false,
      };
    case SET_ARCHIVE_LOADING:
      return {
        ...state,
        archiveDataLoading: false,
      };

    default:
      return state;
  }
};

export default archiveSidebarReducer;
